module.exports = __webpack_public_path__ + "static/media/swords-icon.2650167d.svg";